module.exports = __webpack_public_path__ + "static/media/takeaway.b3759165.svg";